// TEMPORÁRIO — mock local, remover no desenvolvimento do backend.
/**
 * Dado de leitura dos Indicadores Mensais, resolvido a partir de
 * `dados-simulados.json`.
 *
 * NENHUMA DATA LITERAL. O JSON guarda a distância em meses até hoje
 * (`mesReferenciaAtras` e, em cada ponto da série, `mesesAtras`); este arquivo
 * monta o `AAAA-MM`. A série mantém a ordem e o tamanho do JSON (7 meses,
 * terminando no mês de referência). Ano-mês escrito à mão envelhece sozinho
 * (CLAUDE.md, "Nenhuma competência literal no mock"); `dadosSimulados.spec.ts`
 * falha se alguém escrever um no JSON.
 */

import { anoMesAtras } from '../datasRelativas';
import DADOS_SIMULADOS from './dados-simulados.json';
import type { DadosIndicadoresMensais, PontoSerieMensal } from './tipos';

interface DadosBrutos extends Omit<DadosIndicadoresMensais, 'mesReferencia' | 'serieMensal'> {
  mesReferenciaAtras: number;
  serieMensal: (Omit<PontoSerieMensal, 'mes'> & { mesesAtras: number })[];
}

export function carregarIndicadoresMensais(hoje = new Date()): DadosIndicadoresMensais {
  const { mesReferenciaAtras, serieMensal, ...resto } = DADOS_SIMULADOS as DadosBrutos;
  return {
    ...resto,
    mesReferencia: anoMesAtras(mesReferenciaAtras, hoje),
    serieMensal: serieMensal.map(({ mesesAtras, ...ponto }) => ({
      ...ponto,
      mes: anoMesAtras(mesesAtras, hoje),
    })),
  };
}

export const DADOS_INDICADORES_MENSAIS = carregarIndicadoresMensais();
